export class Customer {
    customerId: number;
    name: string;
    domainName: string;
    licenseType: string;
    country: string;
    dateFormat: string;
    expiryDate: Date;
    blobStorageLocation: string;
    timeZone: string;
    timeZoneOffset: number;
}